<ng-template elderToolbarColumn="right.actions">
  <app-facility-context-menu></app-facility-context-menu>
</ng-template>

<elder-basic-pane-layout class="full">
  <elder-pane>
    <app-prod-order-browser class="flex" [facility]="facilityId$ | async"> </app-prod-order-browser>
  </elder-pane>
</elder-basic-pane-layout>
